export default __webpack_public_path__ + "static/PatrickHand-Regular-9469f391b3853213e2f40f9f86af01d7.ttf";